import { render, staticRenderFns } from "./group-tag.vue?vue&type=template&id=2cf287f6&scoped=true"
import script from "./group-tag.vue?vue&type=script&lang=js"
export * from "./group-tag.vue?vue&type=script&lang=js"
import style0 from "./group-tag.vue?vue&type=style&index=0&id=2cf287f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf287f6",
  null
  
)

export default component.exports